import axios, { AxiosResponse } from "axios";
import createCancelableRequest from "@/utils/axiosCancelable";
import hasToken from "@/helper/hasToken";

const userToken: any = hasToken()?.replaceAll('"', "");
const URL = "https://examiner-ai.site/api/flexaminer";
const authKey = "fohe123$";

const examinerAxios = axios.create({
  baseURL: URL,
  headers: {
    Authorization: authKey,
  },
});

interface ExaminerEducationExam {
  date: string;
  time: string;
  examStatusId: number;
}

export default class ExaminerAIService {
  public static examAndEducationCancelableRequest = createCancelableRequest("examinerAIRandomID");

  public static async findPredictionForStudent(data: any): Promise<any> {
    try {
      const response = await examinerAxios.post("/inference_minimal", {
        ...data,
        token: userToken,
      });
      return response.data;
    } catch (err) {
      console.error("Prediction error / No prediction", err);
      throw err;
    }
  }

  public static async checkFeedbackEligibility(educationId: string | number): Promise<any> {
    try {
      const response = await examinerAxios.post("/feedback_eligibility", {
        student_education_id: educationId,
        token: userToken,
      });
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  public static async submitUserFeedback(data: any): Promise<any> {
    try {
      const response = await examinerAxios.post("/feedback_minimal", data);
      return response.data;
    } catch (err) {
      console.error("Feedback error:", err);
      throw err;
    }
  }

  public static async fetchEarliestEducationExam(studentEducationId: string | number): Promise<any> {
    let educationExams: ExaminerEducationExam[] = [];

    try {
      const response: AxiosResponse<ExaminerEducationExam[]> = await this.examAndEducationCancelableRequest.makeRequest({
        url: `/examiner/${studentEducationId}/education-exams`,
        method: "get",
      });
      educationExams = response.data;
    } catch (error) {
      console.log("Error fetching education exams");
      return "no-exam";
    }

    if (!educationExams || educationExams.length === 0) {
      return "no-exam";
    }

    // Sort by combined date and time
    educationExams.sort((a, b) => {
      const dateTimeA = new Date(`${a.date}T${a.time}`).getTime();
      const dateTimeB = new Date(`${b.date}T${b.time}`).getTime();
      return dateTimeA - dateTimeB;
    });

    return educationExams[0].date + " " + educationExams[0].time;
  }
}
